import { Dialog, Toggle } from "client/Components";
import { NoUniqueInputIdContext } from "client/Contexts/UniqueInputIdContext";
import { IAttachableCheckboxPropsWithBuilder } from "client/Forms/attachableProps/checkbox";
import { generateTrackingId, setTrackingId } from "client/Misc/utils";
import {
	PropsWithChildren,
	ReactElement,
	useCallback
} from "react";
import styles from "./NotificationSection.module.less";

export type NotificationSectionProps = {
	title: string;
	trackingId: string;
};

export const NotificationSection = (props: PropsWithChildren<NotificationSectionProps>): ReactElement => {
	const {
		title,
		trackingId,
		children
	} = props;

	return (
		<div {...setTrackingId(trackingId)}>
			<h3
				{...setTrackingId("title")}
				className={styles.title}
			>
				{title}
			</h3>

			{children}
		</div>
	);
};
NotificationSection.displayName = "NotificationSection";

export const NotificationSectionItemList = (props: PropsWithChildren<{}>): ReactElement => {
	const {
		children
	} = props;

	return (
		<ul
			{...setTrackingId("items")}
			className={styles.items}
		>
			{children}
		</ul>
	);
};
NotificationSectionItemList.displayName = "NotificationSection.ItemList";

type NotificationSectionItemProps = {
	label: string;
	subtext: string;
	attachable: IAttachableCheckboxPropsWithBuilder<boolean>;
};

const NotificationSectionItem = (props: NotificationSectionItemProps): ReactElement => {
	const {
		label,
		subtext,
		attachable
	} = props;

	const clickHandler = useCallback(
		(): void => attachable.onChange(!attachable.value),
		[attachable]
	);

	return (
		<li>
			<Dialog.Card
				trackingId={generateTrackingId(attachable.trackingId, "__wrapper")}
				onClick={clickHandler}
			>
				<NoUniqueInputIdContext>
					<div className={styles.item}>
						<div className={styles.itemTextContainer}>
							<p className={styles.itemLabel}>{label}</p>
							<p className={styles.itemSubtext}>{subtext}</p>
						</div>
						<div>
							<Toggle {...attachable} />
						</div>
					</div>
				</NoUniqueInputIdContext>
			</Dialog.Card>
		</li>
	);
};
NotificationSectionItem.displayName = "NotificationSection.Item";

NotificationSection.ItemList = NotificationSectionItemList;
NotificationSection.Item = NotificationSectionItem;
